import { Formik } from "formik";
import styled from "styled-components";
import { Form } from "react-bootstrap";
import LayerDropdown from "../../layerDropdown/LayerDropdown";
import { LayerType } from "../../../constant/LayerType";
import * as Yup from "yup";
import { DateTime } from "luxon";

const FilterGrid = styled.div`
  display: grid;
  grid-template-columns: 33% 33% 33%;
  width: 100%;
  gap: 0.2rem;
`;

interface RoyaltyFiltersProps {
  from: DateTime;
  to: DateTime;
  layer?: LayerType;
  onChange: (e: { from: DateTime; to: DateTime; layer?: LayerType }) => void;
}

const validationSchema = Yup.object().shape({
  from: Yup.date().required(),
  to: Yup.date().required(),
  layer: Yup.mixed<LayerType>().oneOf(Object.values(LayerType)).optional(),
});

const RoyaltyFilters = ({ from, to, layer, onChange }: RoyaltyFiltersProps) => {
  const initialValues = {
    from: from.toISO()!.split("T")[0],
    to: to.toISO()!.split("T")[0],
    layer,
  };

  const filterSubmit = (values: {
    from: string;
    to: string;
    layer?: LayerType;
  }) => {
    onChange({
      from: DateTime.fromISO(values.from),
      to: DateTime.fromISO(values.to),
      layer: values.layer,
    });
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={filterSubmit}
      validationSchema={validationSchema}>
      {({ values, handleSubmit, handleChange }) => (
        <FilterGrid>
          <Form.Group className="px-1">
            <Form.Label>From</Form.Label>
            <Form.Control
              type="date"
              value={values.from}
              onChange={(e) => {
                handleChange(e);
                handleSubmit();
              }}
              name="from"
            />
          </Form.Group>
          <Form.Group className="px-1">
            <Form.Label>To</Form.Label>
            <Form.Control
              type="date"
              value={values.to}
              onChange={(e) => {
                handleChange(e);
                handleSubmit();
              }}
              name="to"
            />
          </Form.Group>
          <Form.Group className="px-1">
            <Form.Label>Layer:</Form.Label>
            <LayerDropdown
              value={values.layer}
              onChange={(e) => {
                handleChange(e);
                handleSubmit();
              }}
            />
          </Form.Group>
        </FilterGrid>
      )}
    </Formik>
  );
};

export default RoyaltyFilters;
